import IUserMenu from '../interfaces/IUserMenu';

const normalizePath = (value?: string) => `/${(value ?? '').trim().replace(/^\/+/, '')}`.replace(/\/+/g, '/').toLowerCase();
const normalizeKey = (value?: string) => (value ?? '').trim().replace(/^\/+/, '').replace(/\/+$/, '').toLowerCase();
const menuRouteSource = (item?: Partial<IUserMenu['item']> | any) => item?.url || item?.code || '';

const menuUrlToUiRoute = (url?: string) => {
  const raw = normalizeKey(url);
  if (!raw) return '/';

  if (raw === 'dashboard') return '/dashboard-restaurant';
  if (raw === 'dashboard-restaurant') return '/dashboard-restaurant';
  if (raw === 'restaurant') return '/restaurant';
  if (raw === 'restaurant-map' || raw === 'restaurantmap') return '/restaurant-map';
  if (raw === 'hotelinfo') return '/hotel';
  if (raw === 'hotelrooms') return '/rooms';
  if (raw === 'hotelroomtypes') return '/roomtypes';
  if (raw === 'hotelpricing') return '/hotelpricing';
  if (raw === 'bookingchannel') return '/booking-channel';
  if (raw === 'roomhandover' || raw === 'room-handover') return '/room-handover';
  if (raw === 'expenses') return '/expenses';
  if (raw === 'expensecategories' || raw === 'expense-categories') return '/expenses';

  if (raw.includes('printers')) return '/printers';
  if (
    raw.includes('settings/integrations') ||
    raw.includes('settings/integratyions') ||
    (raw.includes('settings') && raw.includes('integrat')) ||
    raw.endsWith('/integration') ||
    raw === 'integration'
  ) {
    return '/integration';
  }

  const withoutApiPrefix = raw.replace(/^api\//, '');
  const noDomain = withoutApiPrefix.replace(/^[a-z]+:\/\/[^/]+/i, '');
  const cleaned = withoutApiPrefix === noDomain ? withoutApiPrefix : noDomain.replace(/^\/+/, '');
  if (!cleaned) return '/dashboard-restaurant';

  return normalizePath(cleaned);
};

const flattenMenuItems = (menuData: IUserMenu[] = []) =>
  menuData.flatMap((menuItem) => [menuItem.item, ...(menuItem.subItems ?? [])]);

export const hasMenuRouteAccess = (menuData: IUserMenu[] = [], pathname?: string, routeKey?: string) => {
  const normalizedPath = normalizePath(pathname);
  const normalizedRouteKey = normalizeKey(routeKey);

  return flattenMenuItems(menuData).some((item) => {
    const source = menuRouteSource(item);
    const itemRouteKey = normalizeKey(source);
    const itemUiPath = menuUrlToUiRoute(source);

    return (
      (normalizedRouteKey && itemRouteKey === normalizedRouteKey) ||
      itemUiPath === normalizedPath ||
      (normalizedRouteKey && itemUiPath === normalizePath(normalizedRouteKey))
    );
  });
};

export const normalizeRoutePath = (pathname?: string) => normalizePath(pathname);
